import type { Router } from 'vue-router';

/**
 * 跨平台账号已改为登录时静默归一，不再弹「账号合并」确认框。
 * 保留此函数供登录回调统一跳转。
 */
export async function promptAccountMergeIfPending(
  router: Router,
  defaultRedirect: string,
  _userInfo?: unknown,
): Promise<void> {
  await router.push(defaultRedirect);
}
